<script setup lang="ts">
import Question from "./fields/Question.vue";
import RadioSet from "./fields/RadioSet.vue";
import Radio from "./fields/Radio.vue";
import Checkbox from "./fields/Checkbox.vue";
import { useFinallyStore } from "../stores/finally";
import { finallyValidator } from "../utils/validators";
import { computed } from "vue";

const store = useFinallyStore();

const consentClass = computed(() => {
    switch (store.consent) {
        case true:
            return {
                agree: "consentColor",
                disagree: "deleted-text",
            };
        case false:
            return {
                agree: "deleted-text",
                disagree: "consentColor",
            };
        default:
            return {
                agree: "",
                disagree: "",
            };
    }
});

</script>

<template>
    <div
        class="row"
        data-test="finally"
    >
        <div class="alert alert-info">
            <strong>Annuity providers market quotes consent</strong>
            <br><br>
            <p>
                I <span
                    data-test="consent-agree"
                    :class="consentClass.agree"
                >agree</span> / <span
                    data-test="consent-disagree"
                    :class="consentClass.disagree"
                >do not agree</span>
                to the personal and
                medical information I provided to Annuity Ready being used by their panel of annuity providers,
                to obtain an open market price comparison. This is to ensure they are offering me the highest
                possible quote (in accordance with Financial Conduct Authority Regulations).
            </p>
            <br>
            <p>
                Note: You do not have to agree in order to get a quote.
            </p>
            <br>
            <p>
                If you do not agree, the annuity provider’s quote (key facts) documents will not display a chart comparing their quote to that of other providers. However, the comparisons will still be available on the results page.
            </p>
        </div>
    </div>
    <Question
        name="consent"
    >
        <RadioSet>
            <Radio
                v-model="store.consent"
                title="I agree"
                :value="true"
                :validation="finallyValidator.consent"
            />
            <Radio
                v-model="store.consent"
                title="do not agree"
                :value="false"
                :validation="finallyValidator.consent"
            />
        </RadioSet>
    </Question>
    <div class="row">
        <p class="alert alert-info">
            <strong>Annuity Ready consent </strong>
            <br><br>
            To provide you with annuity quotes, we will share the information you have entered in this form with our panel of providers and trusted quote services.
        </p>

        <div class="alert alert-info">
            <strong class="mb-3">Marketing consent </strong>
            <br><br>
            <p>
                We take your privacy seriously and will never share your personal details with anyone else for their own marketing purposes.
                However, from time to time we would like to contact you with news, useful information and exclusive offers on products and services offered by Investment Discounts On Line Ltd brands.
                If you'd like to be kept up to date, please let us know how you would like to hear from us:
            </p>
        </div>
    </div>
    <div>
        <Question
            name=""
        >
            <Checkbox
                id="email-marketing"
                v-model="store.email"
                title="Email"
            />
            <Checkbox
                id="online-marketing"
                v-model="store.personalizedOnlineMarketing"
                title="Personalised Online Marketing"
            />
            <Checkbox
                id="telephone-marketing"
                v-model="store.telephone"
                title="Telephone"
            />
            <Checkbox
                id="post-marketing"
                v-model="store.post"
                title="Post"
            />
        </Question>
    </div>
</template>
